import { ReactNode } from 'react';
import { AuthedPage, HeaderFooterLayout } from '../app';
import { BackToMyProjectsButton } from './shared-components/BackToMyProjectsButton';
import { UpdateProjectDatesModalProvider } from '../dashboard/my-projects/Modals/UpdateProjectDatesModal';

export const HubPage = ({
  projectDetails,
  progressAccordions,
  sideBarContent,
}: {
  projectDetails: ReactNode;
  progressAccordions: ReactNode;
  sideBarContent: ReactNode;
}) => {
  return (
    <AuthedPage>
      <HeaderFooterLayout useDashboardHeader>
        <UpdateProjectDatesModalProvider>
          <div className='w-full md:max-w-[1280px] mx-auto px-4 md:px-20 mb-10 mt-4 md:-mt-4 text-gray-700'>
            <div className='flex flex-col gap-10 pb-8 border-b border-gray-100'>
              <BackToMyProjectsButton />
              {projectDetails}
            </div>
            <div className='mx-auto mt-8 md:flex gap-8'>
              <div className='flex-grow border border-gray-100 rounded-xl h-fit overflow-auto'>
                {progressAccordions}
              </div>
              <div className='flex flex-col mt-8 md:mt-0 gap-8'>{sideBarContent}</div>
            </div>
          </div>
        </UpdateProjectDatesModalProvider>
      </HeaderFooterLayout>
    </AuthedPage>
  );
};
